import { render, staticRenderFns } from "./forget-password.vue?vue&type=template&id=cac49f06&scoped=true"
import script from "./forget-password.vue?vue&type=script&lang=js"
export * from "./forget-password.vue?vue&type=script&lang=js"
import style0 from "./forget-password.vue?vue&type=style&index=0&id=cac49f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac49f06",
  null
  
)

export default component.exports